/* eslint-disable */
import axios from '@/services/axios'

export default {
    getTrendKeywordDataTable(search, source) {
        return axios.post("/trendkeyword/getTrendKeywordDataTable", search, { cancelToken: source.token });
    },

    getTrendKeywordDataBar(search, source) {
        return axios.post("/trendkeyword/getTrendKeywordDataBar", search, { cancelToken: source.token });
    },

    getTrendKeywordDataBarExp(search, source) {
        return axios.post("/trendkeyword/getTrendKeywordDataBarExp", search, { cancelToken: source.token });
    },

    getLatestMonthSearchVolume(search, source) {
        return axios.post("/trendkeyword/getLatestMonthSearchVolume", search, { cancelToken: source.token });
    },

    getLatestMonthSearchVolumeExp(search, source) {
        return axios.post("/trendkeyword/getLatestMonthSearchVolumeExp", search, { cancelToken: source.token });
    },

    getmajorclasslist(search, source) {
        return axios.get("/trendkeyword/getmajorclasses", { params: search, cancelToken: source.token });
    },

    getmiddleclasslist(search, source) {
        return axios.get("/trendkeyword/getmiddleclasses", { params: search, cancelToken: source.token });
    },
};
